"use strict";
// Copyright (c) 2021 by Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractModule = void 0;
const composition_api_1 = require("@vue/composition-api");
const Module_hooks_1 = require("./Module.hooks");
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.AbstractModule = composition_api_1.defineComponent({
    name: 'AbstractModule',
    props: Module_hooks_1.moduleProps,
    setup: Module_hooks_1.useModule,
    computed: {
        resolveInnerComponent() {
            throw new Error('AbstractModule: Missing implementation of [resolveInnerComponent] computed.');
        }
    },
    methods: {
        scale(step, axis) {
            this.resize(step, axis);
        }
    },
    template: `
    <div :style="gridTemplate">
      <div class="builder__module-inner" :class="decoration" :id="definition.module"
           v-bind="showControls ? { tabindex: 0, role: 'option' } : null"
           @focus="$emit('select')" @blur="$emit('deselect')"
           @mousedown="e => { e.stopImmediatePropagation(); $emit('toggle') }">
        <component :is="resolveInnerComponent" :data="resolvedModule" v-bind="elementProps"
                   @decorate="onDecorationChange" />
      </div>

      <div v-if="showControls" class="handler --module-handler"><i class="fa fa-arrows-alt"></i></div>
      
      <div class="builder__module-controls" v-if="showControls">
        <div class="controls">
          <button v-if="controls.editModule" type="button" class="control" tabindex="-1"
                  @click.stop="triggerEvent('editModule')" @mousedown.prevent>
            <i class="fa fa-pen"></i>
          </button>
          <button v-if="controls.copyModule" type="button" class="control" tabindex="-1"
                  @click.stop @mousedown.prevent>
            <i class="fa fa-copy"></i>
          </button>
          <button v-if="controls.cloneModule" type="button" class="control" tabindex="-1"
                  @click.stop="clone" @mousedown.prevent>
            <i class="fa fa-clone"></i>
          </button>
          <button v-if="controls.removeModule" type="button" class="control" tabindex="-1"
                  @click.stop="triggerEvent('removeModule')" @mousedown.prevent>
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
      
      <template v-if="showControls && isResizable">
        <button type="button" class="positioning-control make-higher" tabindex="-1"
                @click.stop="scale(1, 'y')" @mousedown.prevent>
          <i class="fa fa-plus"></i>
        </button>
        <button type="button" class="positioning-control make-lower" tabindex="-1"
                @click.stop="scale(-1, 'y')" @mousedown.prevent>
          <i class="fa fa-minus"></i>
        </button>
        <button type="button" class="positioning-control make-wider" tabindex="-1"
                @click.stop="scale(1, 'x')" @mousedown.prevent>
          <i class="fa fa-plus"></i>
        </button>
        <button type="button" class="positioning-control make-narrower" tabindex="-1"
                @click.stop="scale(-1, 'x')" @mousedown.prevent>
          <i class="fa fa-minus"></i>
        </button>
      </template>
    </div>
  `
});
//# sourceMappingURL=Module.js.map